var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style['adl-expandable-menu']},[_vm._l((_vm.sections),function(section){return [_c('mds-section',{attrs:{"border":"none","size":8,"bold":true,"title":section.name}},[_c('adl-menu',{class:_vm.$style['sections'],attrs:{"sectionId":section.id,"menus":_vm.menus,"subMenus":_vm.subMenus},on:{"onClick":_vm.onClick}})],1)]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }